import React, {useState, useRef, useLayoutEffect} from 'react';

import SelectedImagePreview from 'views/product/SelectedImagePreview';

const ImgUploadForm = ({previewId, className, defaultPreviewImg, imgWidth, imgHeight, imgInfo, onUpload, onImgChange, onImgReset, addOnly}) => {
    const [uploadedImgFile, setUploadedImgFile] = useState(null);
    const uploadBtn = useRef(null);
    const fileInput = useRef(null);

    const onChange = (e) => {
        if(e.target.files.length > 0) {
            const uploadedFile = e.target.files[0];
            setUploadedImgFile(uploadedFile);

            if(typeof onImgChange === 'function')
                onImgChange(uploadedFile);
        }
    };

    const onReset = () => {
        setUploadedImgFile(null);
        fileInput.current.value = '';

        if(typeof onImgReset === 'function')
            onImgReset();
    };

    const onUploadClick = function() {
        if(uploadedImgFile === null)
            return;
        
        //pass new image file and old image
        onUpload(uploadedImgFile);
        uploadBtn.current.setAttribute("disabled", true);
        uploadBtn.current.innerHTML = "<i class='fa fa-circle-o-notch fa-spin' aria-hidden='true'></i>";
    };

    useLayoutEffect(() => {
        setUploadedImgFile(null);
    }, [defaultPreviewImg]);//uploadedImg gets updated by the API call, so when that happens, reset the profile pic

    
    const showAddIcon = addOnly && !defaultPreviewImg;
    
    const uploadIcon = showAddIcon? <i style={uploadedImgFile? {visibility: 'hidden'}: {}} className="fa fa-plus" aria-hidden="true"></i>:
                                    <i style={uploadedImgFile? {visibility: 'hidden'}: {}} className="fa fa-camera-retro" aria-hidden="true"></i>;
    
    const showUploadIcon = showAddIcon || !addOnly

    return (
    <div className={"imgUploadForm "+(className? className: '')} style={{width: imgWidth, height: 'auto'}}>
        <SelectedImagePreview style={{width: "100%", minHeight: 'unset', height: imgHeight}} 
                id={previewId} file={uploadedImgFile} src={defaultPreviewImg} />
        {
            showUploadIcon && 
            <label htmlFor={previewId+"Input"} className="imgUploader" style={uploadedImgFile? {backgroundColor: 'unset'}: {}} >
                {uploadIcon}
            </label>
        }
        
        <input style={{display: 'none'}} id={previewId+"Input"}
                name={previewId+"Input"} type="file" accept=".png, .jpg, .jpeg"
                onChange={onChange} ref={fileInput} />

        {
            imgInfo && 
            <div style={{color: 'gray', fontSize: '80%'}} className="imgDimensionInfo">{imgInfo}</div>
        }
        

        {
            uploadedImgFile && 
            <span className="closeUploadedPic" onClick={onReset}><i className="fa fa-window-close-o" aria-hidden="true"></i></span>
        }

        {
            uploadedImgFile && (typeof onUpload === 'function') &&
            <button onClick={onUploadClick} ref={uploadBtn}
                style={{width:'100px', height: '25px', marginTop: '10px', cursor: 'pointer', background: 'unset'}}>
                    <i className="fa fa-upload" aria-hidden="true"></i> Upload
            </button>
        }

    </div>)
};


export default ImgUploadForm;


// WEBPACK FOOTER //
// ./src/views/ImgUploadForm.js